import { Box, Stack, Typography } from '@mui/material';
import theme from 'theme';

const VoicePreviewContentAction = ({ heading, message }: { heading: string; message?: string }) => (
    <Stack>
        <Typography
            fontWeight="500"
            letterSpacing="2px"
            marginTop={2}
            variant="body2"
            sx={{ color: theme.palette.secondary.main }}
        >
            {heading}
        </Typography>
        {!!message && (
            <Box
                marginTop={1}
                padding={1.25}
                sx={{
                    backgroundColor: theme.palette.other.tableHover,
                    borderRadius: 0.5,
                }}
            >
                <Typography variant="body2">{message}</Typography>
            </Box>
        )}
    </Stack>
);

export default VoicePreviewContentAction;
